export default "__VITE_ASSET__CkzUWfAg__"